import _slicedToArray from "/Users/janjelschen/apploft/tln/tln_lottonds_backend/deployments/firebase/apploft_cloud_react_modules/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

/**
 * Submission.js
 *
 * Before submitting form data some preparing is due.
 *
 * Copyright (c) apploft. GmbH
 */

/**
 * Returns `null` if `string` is empty.
 *
 * @param {string} string
 */
function nullify(string) {
  if (typeof string !== 'string') {
    return string;
  }

  return string.trim() === '' ? null : string;
}

var SEPARATOR = ':';
/**
 * Returns mangled `names`. For example, `payload:title`.
 *
 * @param  {...string} names
 */

function mangle() {
  for (var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++) {
    names[_key] = arguments[_key];
  }

  for (var _i = 0, _names = names; _i < _names.length; _i++) {
    var name = _names[_i];

    if (typeof name !== 'string') {
      throw new Error('must be strings');
    }
  }

  return names.join(SEPARATOR);
}
/**
 * Returns [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) string if
 * `value` is a `Date`.
 *
 * @param {*} value
 */


function datify(value) {
  if (value instanceof Date) {
    return value.toISOString();
  }

  return value;
}
/**
 * Returns datified `formData[key]` or `formData[key].value`.
 *
 * @param {*} formData
 * @param {string} key
 */


function createValue(formData, key) {
  var obj = formData[key];

  if (!obj) {
    return obj;
  }

  var value = obj.value;

  if (value) {
    return datify(value);
  }

  return datify(obj);
}
/**
 * Returns HTTP payload from `formData`.
 *
 * @param {*} formData
 */


function createRequestData(formData) {
  return Object.keys(formData).reduce(function (acc, key) {
    var meta = key.split(SEPARATOR);
    var value = createValue(formData, key);

    if (meta.length === 1) {
      acc[key] = nullify(value);
      return acc;
    }

    if (meta.length !== 2) {
      throw new Error('unexpected key');
    }

    var _meta = _slicedToArray(meta, 2),
        fieldset = _meta[0],
        name = _meta[1];

    if (!acc[fieldset]) {
      acc[fieldset] = {};
    }

    acc[fieldset][name] = nullify(value);
    return acc;
  }, {});
}

export { nullify, createRequestData, mangle };